import { useEffect, useState } from 'react'
import { referralApi, type ReferralMe } from '../api/referral'

const WRAP: React.CSSProperties = {
  margin: '0 0 20px',
  padding: 20,
  borderRadius: 12,
  border: '1px solid var(--line, #E5E9EF)',
  background: 'var(--bg-sunk, #F7F9FC)',
}

// Account-page referral card: the all-user referral hub — share your code,
// friends get a discount on their first order, you earn Nimvoy Credit.
// Renders only when the program is enabled.
// English-only for now — i18n is a pre-enable follow-up.
export function ReferralWidget() {
  const [data, setData] = useState<ReferralMe | null>(null)
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    referralApi.hubMe().then(setData).catch(() => setData(null))
  }, [])

  if (!data) return null
  if (!data.program_enabled) return null

  const reward = `$${(data.reward_per_referral_cents / 100).toFixed(0)}`
  const copy = () => {
    navigator.clipboard
      ?.writeText(data.code)
      .then(() => {
        setCopied(true)
        setTimeout(() => setCopied(false), 1500)
      })
      .catch(() => {})
  }

  return (
    <div style={WRAP}>
      <div style={{ fontWeight: 600, fontSize: 16, marginBottom: 4 }}>
        Refer friends, get {reward}
      </div>
      <div style={{ fontSize: 14, color: 'var(--ink-2, #51637A)', marginBottom: 14 }}>
        Share your code. Friends enter it at checkout for {data.discount_rate_pct}% off their first
        order — you earn {reward} in Nimvoy Credit when they buy.
      </div>

      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <input
          readOnly
          value={data.code}
          onFocus={(e) => e.currentTarget.select()}
          style={{
            flex: '1 1 200px',
            padding: '10px 12px',
            borderRadius: 8,
            border: '1px solid var(--line, #E5E9EF)',
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'monospace',
            letterSpacing: '0.04em',
            background: '#fff',
          }}
        />
        <button className="btn ghost" onClick={copy}>
          {copied ? 'Copied!' : 'Copy code'}
        </button>
      </div>

      <div style={{ display: 'flex', gap: 24, marginTop: 16, fontSize: 13 }}>
        <div>
          <div style={{ color: 'var(--ink-3, #8896A8)' }}>Friends joined</div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>{data.friends_joined}</div>
        </div>
        <div>
          <div style={{ color: 'var(--ink-3, #8896A8)' }}>Credit earned</div>
          <div style={{ fontSize: 18, fontWeight: 600 }}>
            ${(data.reward_earned_cents / 100).toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  )
}
